<div>
  <app-nav-bar></app-nav-bar>
</div>

<p-toast></p-toast>
